/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
    'use strict';

    /**
     * Вид для группы форм адресной доставки
     */
    app.JointPurchaseDeliveryAddressFormsView = app.JointPurchaseDeliveryFormsView.extend({
        el: '',

        templateName: '#template-delivery-address-group-form',

        events: {
            'click .js-add-delivery-address-district': 'addDeliveryDistrict',
            'click .js-delete-button': 'deleteGroupForms'
        },

        /**
         * Рендерит новое поле для адресной доставки
         *
         * @param model
         * @param collection
         */
        renderNewDeliveryForm: function (model, collection) {
            var newDeliveryAddressFormView = new app.JointPurchaseDeliveryAddressFormView({
                model: model,
                collection: collection,
                jpDistricts: this.jpDistrictModels,
                districts: this.districts,
                settlement: this.settlement
            });
            if (this.districts && this.districts.length) {
                this.$('.js-delivery-address-forms-list').append(newDeliveryAddressFormView.render());
            } else {
                this.$('.js-delivery-address-single-form').append(newDeliveryAddressFormView.render());
            }
            this.childViews.formViews.push(newDeliveryAddressFormView);
        },

        /**
         * Добавляет запись адресной доставки
         */
        addDeliveryDistrict: function () {
            var that = this,
                district = null;
            if (this.districts.length) {
                _.each(this.districts.models, function (d) {
                   if (!that.model.findWhere({district_id: d.get('id')})) {
                       district = d;
                       return false;
                   }
                });
            }
            this.model.create({
                user_id: app.user.get('id'),
                settlement_id: this.settlement.id || this.settlement.settlement_id,
                district_id: district ? district.get('id') : null,
                district: district ? district.toJSON() : null,
                price: 0
            });
        },

        /**
         * Переключает видимость кнопок интерфейса
         */
        toggleButtons: function () {
            if (this.model.length > 1) {
                this.$('.js-delivery-address-forms-list .js-delete-button').removeClass('not_display');
            } else {
                this.$('.js-delivery-address-forms-list .js-delete-button').addClass('not_display');
            }
            if (this.model.length < this.districts.length) {
                this.$('.js-add-delivery-address-district').removeClass('not_display');
            } else {
                this.$('.js-add-delivery-address-district').addClass('not_display');
            }
        }
    });
})();

}.call(window));